import MultipleChoiceQuestionTask from 'models/task/question/questionTask/choice/MultipleChoiceQuestionTask';

/**
 * Class representing a text multiple choice question task.
 * @extends MultipleChoiceQuestionTask
 */
export default class TextMultipleChoiceQuestionTask extends MultipleChoiceQuestionTask {}
